import { InStoreLocation } from '../../../../../core';

const iconsOfActionsList = [
  {
    icon: 'edit',
    tooltip: 'Editar',
    hasVisibleCondition: (element: InStoreLocation[]): boolean => {
      return element.length === 1;
    }
  },
  {
    icon: 'trash',
    tooltip: 'Eliminar',
    hasVisibleCondition: (element: InStoreLocation[]): boolean => true
  }
];

export const inStoreLocation = {
    searchText: 'Buscar ubicación',
    addText: '',
    export: true,
    exportFile: 'Ubicaciones de retiro en tienda.xlsx',
    expandable: false,
    checkbox: true,
    filter: false,
    filterDefault: '',
    disabled: false,
    partialField: '',
    iconsOfActions: iconsOfActionsList,
    hasDisabledCheckBoxItem: (item: any) => false,
    show: 'Aún no tenemos registro para mostrar, seleccione otra opción',
    columns: [
      {
        title: 'Entidad',
        name: 'entityName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left inStoreLocation-entityName',
        value: (element: InStoreLocation) => element.entityName
      },
      {
        title: 'Cód. Ubicación',
        name: 'locationCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: InStoreLocation) => element.locationCode
      },
      {
        title: 'Zona en la tienda',
        name: 'zone',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: InStoreLocation) => element.zone
      }
      /* { Comentado temporalmente
        title: 'Disponibilidad',
        name: 'busy',
        type: 'button',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: InStoreLocation) => {
          return {
            data: element.busy,
            icon: 'fiber_manual_record',
            value: element.busy ? 'Ocupado' : 'Desocupado',
            style: element.busy ? 'recordColumn icon-busy-not' : 'recordColumn icon-busy',
            showTitle: true
          };
        }
      } */
    ]
  };



